import { render } from "./ClientManagerLayout.vue?vue&type=template&id=dc21834e"
import script from "./ClientManagerLayout.vue?vue&type=script&lang=js"
export * from "./ClientManagerLayout.vue?vue&type=script&lang=js"

import "./ClientManagerLayout.vue?vue&type=style&index=0&id=dc21834e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__